// Shared filename builder so report downloads use one consistent convention:
//   <BaseName>_<yyyy-MM-dd>.<ext>                      (single-date reports)
//   <BaseName>_<yyyy-MM-dd>_to_<yyyy-MM-dd>.<ext>      (date-range reports)
import { format } from "date-fns";

/**
 * @param {string} baseName  Human name, e.g. "PM Report". Non-word chars become "_".
 * @param {object} [opts]
 * @param {string} [opts.ext="pdf"]
 * @param {Date}   [opts.date=new Date()]  Used when no range is supplied.
 * @param {Date}   [opts.start]            Range start (with opts.end).
 * @param {Date}   [opts.end]              Range end (with opts.start).
 * @returns {string}
 */
export const buildReportFilename = (
  baseName,
  { ext = "pdf", date = new Date(), start, end } = {}
) => {
  const safe = String(baseName).trim().replace(/[^\w-]+/g, "_");
  const stamp =
    start && end
      ? `${format(start, "yyyy-MM-dd")}_to_${format(end, "yyyy-MM-dd")}`
      : format(date, "yyyy-MM-dd");
  return `${safe}_${stamp}.${ext}`;
};

export default buildReportFilename;
